<template>
  <div class="page">
    <Banner :top="0" />

    <div class="pc_ipad">
      <div class="layer1">
        <div class="left">
          <div class="row row1">
            <div>
              <img
                src="~@/assets/spark-go/mobile/photo_pack/a.png"
              >
            </div>
            <div>
              <img
                v-if="play1"
                class="play"
                src="~@/assets/spark-mini/play.png"
                alt=""
                @click="videoClick1"
              >
              <video
                ref="videoPlayer1"
                loop
                :autoplay="!_isMobile()"
                poster="~@/assets/spark-go/mobile/photo_pack/b.png"
                @click="videoClick1"
              >
                <source
                  src="https://assets.positivegrid.com.cn/media/%E7%94%B5%E5%95%86%E7%94%A8-%E6%AD%A3%E5%BC%8F%E4%B8%8A%E5%B8%82%E5%B9%BF%E5%91%8A%E7%89%87-Spark%20GO%20_Nothing%20can%20stop%20you%20now_%20Commercial%201080x1080%20-%20subbed.mp4"
                  type="video/mp4"
                >
              </video>
            </div>
          </div>
          <div class="row row1">
            <div>
              <img
                src="~@/assets/spark-go/mobile/photo_pack/c.png"
              >
            </div>
            <div>
              <img
                src="~@/assets/spark-go/mobile/photo_pack/d.png"
              >
            </div>
          </div>
          <div class="row row1">
            <div>
              <img
                src="~@/assets/spark-go/mobile/photo_pack/e.png"
              >
            </div>
            <div>
              <img
                src="~@/assets/spark-go/mobile/photo_pack/f.png"
              >
            </div>
          </div>
        </div>
        <div class="right">
          <div class="box">
            <img
              class="background"
              src="~@/assets/spark-go/Frame1765.png"
            >
            <div
              class="go-tmail"
              @click="openTmallFun"
            >
              &nbsp;
            </div>
            <div class="androidUrl">
              <a
                :href="androidUrl"
                download=""
                style="cursor:pointer"
                @click="downloadAndroidFun"
              />
            </div>
            <div
              class="iosUrl"
              @click="downIosFun"
            />
            <!-- <div class="right_btn_box">
              <img
                class="price"
                src="~@/assets/spark-mini/1499.png"
              >
              <img
                class="btn"
                src="~@/assets/spark-mini/button.png"
                @click="openTmallFun"
              >

              <a
                :href="androidUrl"
                download=""
                style="cursor:pointer"
                @click="downloadAndroidFun"
              >
                <img
                  class="anzuo"
                  src="~@/assets/spark-mini/anzuo.png"
                  @click="downloadAndroidFun"
                >
              </a>
              <img
                src="~@/assets/spark-mini/ios.png"
                @click="downIosFun"
              >
              <img
                class="text"
                src="~@/assets/spark-mini/text.png"
              >
            </div> -->
          </div>
        </div>
      </div>
      <div class="layer2">
        <div class="video_box">
          <img
            class="img"
            src="~@/assets/spark-go/1.png"
          >
          <div class="video">
            <img
              v-if="play3"
              class="play"
              src="~@/assets/spark-mini/play.png"
              alt=""
              @click="videoClick3"
            >
            <video
              ref="videoPlayer3"
              loop
              poster="~@/assets/spark-go/video2.png"
              @click="videoClick3"
            >
              <source
                src="https://assets.positivegrid.com.cn/media/ola%E7%8C%9B%E7%94%B7%E6%B5%8B%E8%AF%84go-Positive%20Grid%20Spark%20GO%20-%20subbed.mp4"
                type="video/mp4"
              >
            </video>
          </div>
        </div>

        <img
          class="img"
          src="~@/assets/spark-go/2.png"
        >
        <img
          class="img"
          src="~@/assets/spark-go/3.png"
        >
        <img
          class="img"
          src="~@/assets/spark-go/4.png"
        >
        <img
          class="img"
          src="~@/assets/spark-go/5.png"
        >
        <img
          class="img"
          src="~@/assets/spark-go/6.png"
        >
        <swiper
          class="swiper"
          :options="swiperOption"
        >
          <swiper-slide>
            <img
              style="width:100%"
              src="~@/assets/spark-go/WechatIMG212.jpeg"
              alt=""
            >
          </swiper-slide>
          <swiper-slide>
            <img
              style="width:100%"
              src="~@/assets/spark-go/WechatIMG213.jpeg"
              alt=""
            >
          </swiper-slide>
          <swiper-slide>
            <img
              style="width:100%"
              src="~@/assets/spark-go/WechatIMG214.png"
              alt=""
            >
          </swiper-slide>

          <div
            slot="pagination"
            class="swiper-button-prev swiper-button-white"
          />
          <div
            slot="pagination"
            class="swiper-button-next swiper-button-white"
          />
          <div
            slot="pagination"
            class="swiper-pagination"
          />
        </swiper>
        <img
          class="img"
          src="~@/assets/spark-go/8.png"
        >
      </div>
    </div>
    <div class="mobile">
      <img
        class="img"
        style="height:100%"
        src="~@/assets/spark-go/mobile/Top1.png"
      >
      <swiper
        class="swiper"
        :options="swiperOption"
      >
        <swiper-slide>
          <img
            style="width:100%"
            src="~@/assets/spark-go/mobile/photo_pack/b.png"
            alt=""
          >
        </swiper-slide>
        <swiper-slide>
          <img
            style="width:100%"
            src="~@/assets/spark-go/mobile/photo_pack/a.png"
            alt=""
          >
        </swiper-slide>

        <swiper-slide>
          <img
            style="width:100%"
            src="~@/assets/spark-go/mobile/photo_pack/c.png"
            alt=""
          >
        </swiper-slide>
        <swiper-slide>
          <img
            style="width:100%"
            src="~@/assets/spark-go/mobile/photo_pack/d.png"
            alt=""
          >
        </swiper-slide>
        <swiper-slide>
          <img
            style="width:100%"
            src="~@/assets/spark-go/mobile/photo_pack/e.png"
            alt=""
          >
        </swiper-slide>
        <swiper-slide>
          <img
            style="width:100%"
            src="~@/assets/spark-go/mobile/photo_pack/f.png"
            alt=""
          >
        </swiper-slide>
        <!-- <div
          slot="pagination"
          class="swiper-button-prev swiper-button-white"
        />
        <div
          slot="pagination"
          class="swiper-button-next swiper-button-white"
        /> -->
        <div
          slot="pagination"
          class="swiper-pagination"
        />
      </swiper>
      <div class="box">
        <img
          class="img"
          src="~@/assets/spark-go/mobile/3.png"
        >
        <div
          class="to_tmail"
          @click="openTmallFun"
        />
        <div class="androidUrl">
          <a
            :href="androidUrl"
            download=""
            style="cursor:pointer"
            @click="downloadAndroidFun"
          />
        </div>
        <div
          class="iosUrl"
          @click="downIosFun"
        />
      </div>
      <div class="mobile_video1 mobile_video2">
        <img
          v-if="play5"
          class="play"
          src="~@/assets/spark-mini/play.png"
          alt=""
          @click="videoClick5"
        >
        <video
          ref="videoPlayer5"
          loop
          poster="~@/assets/spark-go/a.png"
          @click="videoClick5"
        >
          <source
            src="https://assets.positivegrid.com.cn/media/%E7%94%B5%E5%95%86%E7%94%A8-%E6%AD%A3%E5%BC%8F%E4%B8%8A%E5%B8%82%E5%B9%BF%E5%91%8A%E7%89%87-Spark%20GO%20_Nothing%20can%20stop%20you%20now_%20Commercial%201080x1080%20-%20subbed.mp4"
            type="video/mp4"
          >
        </video>
      </div>
      <div>
        <img
          class="img"
          src="~@/assets/spark-go/mobile/4-1-1.png"
        >
      </div>
      <div>
        <img
          class="img"
          src="~@/assets/spark-go/mobile/4-1-2.png"
        >
      </div>
      <div>
        <img
          class="img"
          src="~@/assets/spark-go/mobile/4-1-3.png"
        >
      </div>
      <div class="mobile_video1">
        <img
          v-if="play4"
          class="play"
          src="~@/assets/spark-mini/play.png"
          alt=""
          @click="videoClick4"
        >
        <video
          ref="videoPlayer4"
          loop
          poster="~@/assets/spark-go/video2.png"
          @click="videoClick4"
        >
          <source
            src="https://assets.positivegrid.com.cn/media/ola%E7%8C%9B%E7%94%B7%E6%B5%8B%E8%AF%84go-Positive%20Grid%20Spark%20GO%20-%20subbed.mp4"
            type="video/mp4"
          >
        </video>
      </div>
      <div>
        <img
          class="img"
          src="~@/assets/spark-go/mobile/4-1-4.png"
        >
      </div>
      <div>
        <img
          class="img"
          src="~@/assets/spark-go/mobile/4-1-5.png"
        >
      </div>
      <div>
        <img
          class="img"
          src="~@/assets/spark-go/mobile/4-2.png"
        >
      </div>
      <div>
        <img
          class="img"
          src="~@/assets/spark-go/mobile/4-3.png"
        >
      </div>
      <div>
        <img
          class="img"
          src="~@/assets/spark-go/mobile/4-4.png"
        >
      </div>
      <swiper
        class="swiper"
        :options="swiperOption"
      >
        <swiper-slide>
          <img
            style="width:100%"
            src="~@/assets/spark-go/WechatIMG212.jpeg"
            alt=""
          >
        </swiper-slide>
        <swiper-slide>
          <img
            style="width:100%"
            src="~@/assets/spark-go/WechatIMG213.jpeg"
            alt=""
          >
        </swiper-slide>
        <swiper-slide>
          <img
            style="width:100%"
            src="~@/assets/spark-go/WechatIMG214.png"
            alt=""
          >
        </swiper-slide>

        <!-- <div
          slot="pagination"
          class="swiper-button-prev swiper-button-white"
        />
        <div
          slot="pagination"
          class="swiper-button-next swiper-button-white"
        /> -->
        <div
          slot="pagination"
          class="swiper-pagination"
        />
      </swiper>
      <div>
        <img
          class="img"
          src="~@/assets/spark-go/mobile/5.png"
        >
      </div>
    </div>
  </div>
</template>
<script>
import Banner from '@/components/banner'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
// import VueCarousel from '@chenfengyuan/vue-carousel'
import axios from 'axios'
import { NEW_API_URL } from '@/urls'
export default {
  components: {
    Banner,
    swiper,
    swiperSlide
    // VueCarousel
  },
  data () {
    let row1 = require('@/assets/spark-mini/row1.png')
    let row2 = require('@/assets/spark-mini/row2.png')
    let row3 = require('@/assets/spark-mini/row3.png')
    let row4 = require('@/assets/spark-mini/row4.png')
    let row5 = require('@/assets/spark-mini/row5.png')
    let row6 = require('@/assets/spark-mini/row6.png')
    return {
      play1: false,
      play2: true,
      play3: true,
      play4: true,
      play5: true,
      slides: [
        `<div> <img src="${row1}" > </div>`,
        `<div> <img src="${row2}" > </div>`,
        `<div> <img src="${row3}" > </div>`,
        `<div> <img src="${row4}" > </div>`,
        `<div> <img src="${row5}" > </div>`,
        `<div> <img src="${row6}" > </div>`
      ],
      androidUrl: '',
      num: 0,
      swiperOption: {
        navigation: {
          nextEl: '.swiper-button-next', // 前进按钮的css选择器或HTML元素。
          prevEl: '.swiper-button-prev' // 后退按钮的css选择器或HTML元素。
        },
        loop: true,
        autoplay: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },

  watch: {},

  created () {
    this.downloadAndroidFun()
  },
  methods: {
    videoClick1 () {
      this.play1 = !this.$refs.videoPlayer1.paused

      this.$refs.videoPlayer1.paused === true
        ? this.$refs.videoPlayer1.play()
        : this.$refs.videoPlayer1.pause()
    },
    videoClick2 () {
      this.play2 = !this.$refs.videoPlayer2.paused
      this.$refs.videoPlayer2.paused === true
        ? this.$refs.videoPlayer2.play()
        : this.$refs.videoPlayer2.pause()
    },
    videoClick3 () {
      this.play3 = !this.$refs.videoPlayer3.paused

      this.$refs.videoPlayer3.paused === true
        ? this.$refs.videoPlayer3.play()
        : this.$refs.videoPlayer3.pause()
    },
    videoClick4 () {
      this.play4 = !this.$refs.videoPlayer4.paused

      this.$refs.videoPlayer4.paused === true
        ? this.$refs.videoPlayer4.play()
        : this.$refs.videoPlayer4.pause()
    },
    videoClick5 () {
      this.play5 = !this.$refs.videoPlayer5.paused

      this.$refs.videoPlayer5.paused === true
        ? this.$refs.videoPlayer5.play()
        : this.$refs.videoPlayer5.pause()
    },
    _isMobile () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    openTmallFun () {
      if (this._isMobile()) {
        this.$refs.videoPlayer1.pause()
        window.open('https://m.tb.cn/h.UFr3qoO?tk=PDdFdnlVxiH')
      } else {
        window.open(
          'https://detail.tmall.com/item.htm?id=714811871008&ns=1&abbucket=3'
        )
      }
    },
    //   download android
    async downloadAndroidFun () {
      this.num += 1
      try {
        await axios
          .get(`${NEW_API_URL}/api/package/spark`, {
            headers: {
              //   'Authorization': `JWT ${this.token || window.localStorage.getItem('PG_TOKEN')}`,
              'Content-Type': 'application/json;charset=UTF-8'
            }
          })
          .then(res => {
            if (res.data.android) {
              let userAgent = navigator.userAgent.toLowerCase()
              if (userAgent.indexOf('android') > -1 && this.num > 1) {
                window.open(res.data.android.download_url)
              } else {
                this.androidUrl = res.data.android.download_url
              }
            }
          })
          .catch(err => {
            console.error('Fail!!', err)
          })
      } catch (err) {
        console.log(err, '请求出错！')
      }
    },
    // download ios
    downIosFun () {
      window.open('https://apps.apple.com/cn/app/id1516758668')
    }
  }
}
</script>
<style lang="scss" scoped>
.pc_ipad {
  display: block;
  padding-top: 54px;
  .video_box {
    position: relative;
    div {
      position: relative;
      flex: 1;
      max-width: 100%;
      img,
      video {
        width: 100%;
      }
      .play {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100px;
        height: 100px;
        transform: translate(-50%, -50%);
      }
    }
    .video {
      position: absolute;
      top: 35%;
      left: 66%;
      width: 28%;
      border-radius: 12px;
      overflow: hidden;
    }
  }
}
.mobile {
  display: none;
}
.page {
  // padding-top: 5.5%;
  background: #fff;
  min-height: 100vh;

  .layer1 {
    display: flex;
    .left {
      flex: 1435;
      padding-right: 1%;
      .row {
        display: flex;
        width: 100%;
        box-sizing: border-box;
        margin-bottom: 10px;
        div:nth-child(1) {
          margin-right: 1%;
        }
        div {
          position: relative;
          flex: 1;
          max-width: 100%;
          img,
          video {
            width: 100%;
          }
          .play {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 20%;
          }
        }
      }
      .row:nth-child(3) {
        margin: 0;
      }
    }
    .right {
      flex: 486;
      box-sizing: border-box;
      text-align: center;
      .box {
        margin: 0 auto;
        // width: 80%;
        position: relative;
        .go-tmail {
          position: absolute;
          left: 50%;
          top: 62%;
          transform: translate(-50%, 0);
          width: 65%;
          height: 4%;
          // background: red;
        }
        .androidUrl{
          position: absolute;
          top: 71.5%;
          left: 50%;
          transform: translate(-47%, 0);
          width: 70%;
          height: 6%;
          a{
            display: block;
            width: 100%;
            height: 100%;
          }
        }
         .iosUrl{
          position: absolute;
          top: 79%;
          left: 50%;
          transform: translate(-47%, 0);
          width: 70%;
          height: 6%;
          a{
            display: block;
            width: 100%;
            height: 100%;
          }
        }
        .background {
          width: 100%;
        }
        .right_btn_box {
          height: 100%;
          position: absolute;
          top: 0;
          left: 50%;
          transform: translate(-50%, 0);
          padding-top: 200%;
          .price {
            margin-bottom: 10%;
          }
          .btn {
            margin-bottom: 120%;
          }
          .anzuo {
            margin-bottom: 10%;
          }
          .text {
            margin: 0 auto;
            margin-top: 8%;
            width: 50%;
          }
        }
      }
    }
  }
  .layer2 {
    .img {
      width: 100%;
    }
  }
  .layer3 {
    margin-top: -25%;
  }

  @media (max-width: 768px) {
    .pc_ipad {
      display: none;
    }

    .mobile {
      min-height: 100%;
      padding-top: 44px;
      background: #fff;
      display: block;
      .mobile_video1 {
        padding: 0 5% 5% 5%;
        position: relative;
        width: 100%;
        overflow: hidden;
        video {
          border-radius: 12px;
        }
        .play {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 100px;
          height: 100px;
          transform: translate(-50%, -50%);
        }
      }
      .mobile_video2 {
        padding: 0;
        video {
          border-radius: 0;
        }
      }
      .box {
        position: relative;
        .to_tmail {
          width: 75%;
          height: 12%;
          position: absolute;
          top: 25%;
          transform: translate(17%, 0);
        }
         .androidUrl{
          position: absolute;
          top: 49.5%;
          left: 50%;
          transform: translate(-50%, 0);
          width: 80%;
          height: 17%;
          a{
            display: block;
            width: 100%;
            height: 100%;
          }
        }
         .iosUrl{
          position: absolute;
          top: 73%;
          left: 50%;
          transform: translate(-50%, 0);
          width: 80%;
          height: 17%;
          a{
            display: block;
            width: 100%;
            height: 100%;
          }
        }
      }

      .img {
        width: 100%;
      }
      .carousel {
        height: 100%;
      }
      .layer2 {
        position: relative;
        text-align: center;

        .right_btn_box {
          width: 100%;
          position: absolute;
          top: 65%;

          .btn {
            margin: 0 auto;
            width: 56%;
          }
          .anzuo {
            margin: 15% auto 0 auto;
            width: 45%;
          }
          .ios {
            margin: 3% auto 0 auto;
            width: 45%;
          }
          .text {
            margin: 3% auto 0 auto;
            width: 25%;
          }
        }
      }
      .layer3 {
        margin-top: 0%;
        position: relative;
        .play {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 20%;
        }
      }
      // .layer4{
      //   img{
      //     width:100%;
      //   }
      // }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/spark-go.vue